import { FieldError, FieldErrors } from "react-hook-form";

// Helpers
import { isArray } from "helpers/is";

// Types
import { ErrornameType, ErrorResponse } from "types/Errors";

export const mappedError = (error) => {
  const result: ErrornameType[] = [];
  if ("data" in error) {
    const errorData = error.data as ErrorResponse;
    if (typeof errorData.message === "string") {
      result.push({
        name: "",
        error: errorData.message,
      });
    } else if (isArray(errorData.message)) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < errorData.message.length; i++) {
        result.push({
          name: Object.keys(errorData.message[i])[0],
          error: Object.values(errorData.message[i])[0],
        });
      }
    } else if (typeof errorData.message === "object") {
      Object.entries(errorData.message).forEach(([name, errorText]) => {
        result.push({
          name,
          error: errorText as unknown as string,
        });
      });
    }
  }
  return result;
};

export const getNameError = (
  errors: FieldErrors,
  name: string,
  error?: string,
): string | null => {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const FieldError: FieldError = errors[name] as FieldError;
  if (FieldError && FieldError.message) {
    return FieldError.message as string;
  }
  if (error) {
    return error;
  }
  return null;
};

export const handleErrors = (error, setErrorFunction, setResponseFunction) => {
  const errors = mappedError(error);
  const errorResponses: string[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const err of errors) {
    if (err.name && setErrorFunction) {
      setErrorFunction(err.name, { type: "value", message: err.error });
    } else if (setResponseFunction) {
      errorResponses.push(err.error);
    }
  }

  if (setResponseFunction && errorResponses.length) {
    setResponseFunction((prev) =>
      prev
        ? [...prev.split("; "), ...errorResponses].join("; ")
        : errorResponses.join("; "),
    );
  }

  return errors;
};
